var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SocialAuthBtn',{staticClass:"wechat-btn",attrs:{"id":"wechat-login-btn","img":_vm.logo,"label":_vm.$t('shared.loginModule.socialAuthBtns.continueWithWeChat'),"color":"#00dd6c","tiny":_vm.tiny},on:{"click":_vm.weChatLogIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }